package com.rajen.angrejidictionary.analytics

import kotlinx.browser.window

object GoogleAnalytics {

    private fun gtag(command: String, name: String, params: dynamic) {
        val fn = window.asDynamic().gtag
        if (jsTypeOf(fn) == "function") fn(command, name, params)
    }

    // GA4 names: letters/digits/underscores only, max 40 chars.
    private fun sanitize(raw: String): String =
        raw.replace(Regex("[^A-Za-z0-9_]"), "_").take(40)

    fun pageView(title: String, path: String) {
        if (path.startsWith("/admin")) return
        val p = js("{}")
        p.page_title = title
        p.page_path = path
        p.page_location = window.location.href
        gtag("event", "page_view", p)
    }

    fun event(name: String, data: dynamic = null) {
        if (name.startsWith("admin-")) return // keep admin activity/usernames out of GA

        val params = js("{}")
        if (data != null && data != undefined) {
            val keys = js("Object.keys(data)").unsafeCast<Array<String>>()
            for (key in keys) {
                val v = data[key]
                params[sanitize(key)] = if (jsTypeOf(v) == "string") v.unsafeCast<String>().take(100) else v
            }
        }
        gtag("event", sanitize(name.replace('-', '_')), params)

        // GA4 recommended event so the built-in search reports populate
        if (name == "word-search" && data != null) {
            val s = js("{}")
            s.search_term = data.term
            gtag("event", "search", s)
        }
    }
}